interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma 75644:18526 "expand (4) 1" — four corner brackets. */
const FigmaFitViewIcon = ({ width = 20, height = 20, color = '#121826' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 2.5V6.66667H19.1667V2.5C19.1667 1.58083 18.4192 0.833333 17.5 0.833333H13.3333V0H17.5C18.8783 0 20 1.12167 20 2.5ZM0 2.5V6.66667H0.833333V2.5C0.833333 1.58083 1.58083 0.833333 2.5 0.833333H6.66667V0H2.5C1.12167 0 0 1.12167 0 2.5ZM0.833333 17.5V13.3333H0V17.5C0 18.8783 1.12167 20 2.5 20H6.66667V19.1667H2.5C1.58083 19.1667 0.833333 18.4192 0.833333 17.5ZM19.1667 17.5C19.1667 18.4192 18.4192 19.1667 17.5 19.1667H13.3333V20H17.5C18.8783 20 20 18.8783 20 17.5V13.3333H19.1667V17.5Z'
      fill={color}
    />
  </svg>
);

export default FigmaFitViewIcon;
